<template>
<div class="announced">
  <div class="tt">{{aTitle}}</div>
  <div class="date">{{aDate|timeString}}</div>
  <div class="content" v-html="aContent"></div>
</div>
</template>

<script>
import utils from '../assets/js/utils'
export default {
  name: 'announced',
  data () {
    return{
      list: [],
      queLst: [],
      aTitle: '',
      aContent: '',
      aDate: '',
      id:utils.getUrlStr('id')
    }
  },
  filters: {
    timeString(timeStamp) {
      if (timeStamp) {
        var date = new Date(timeStamp)
        var newDate = date.getFullYear() + '-' + (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : (date.getMonth() + 1)) + '-' + (date.getDate() < 10 ? '0' + date.getDate() : date.getDate())
        return newDate
      }
    }
  },
  mounted() {
    
    const formData = new FormData()
    formData.append('h5Type',5)
    formData.append('id', utils.getUrlStr('id'))
     this.$http({
        method: 'post',
        url: '/api/mine/html5List',
        data: formData
     }).then((res)=>{
      if(res.data.status === 200){
        if(res.data.data.appHtml5[0].contentType === 1){
          window.location.href = res.data.data.appHtml5[0].h5Content
        }else{
          this.aTitle = res.data.data.appHtml5[0].h5Title
          this.aDate = res.data.data.appHtml5[0].h5CreateTime
          this.aContent = res.data.data.appHtml5[0].h5Content
          document.title = "官方公告"
        }
      }else{

        alert(res.data.msg)
        }
      })
     console.log(this.list)

          $('.announced').on('click','.flexcon',function(){
       if($(this).find('img').data('type')){
        utils.goToApp($(this).find('img').data('type'),$(this).find('img').data('fn'))
      }else if($(this).find('img').data('fn')){
        if( _self.isWeixin){
          window.location.href='http://wx.qianqunke.com/reg?code='+  _self.userId
        } else{
          utils.goToApp('goodid',$(this).find('img').data('fn'))
        }
        
      }
     })
  },
  methods:{
    answer(item) {
      this.ansShow = true
      this.aTitle = item.h5Title
      this.aContent = item.h5Content
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.announced{
  padding: 0 0.75rem 1rem; background: #fff; overflow: hidden;
  .tt{color: #333333; font-size: 0.85rem; margin:0.5rem 0 0.25rem;}
  .date{font-size: 0.65rem; color: #999; margin-bottom: 0.5rem;}
  .content{font-size: 0.75rem;line-height: 1.4rem;}
  img{max-width: 100%;}
}

</style>



// WEBPACK FOOTER //
// src/components/announced.vue